import '../sass/style.scss'

window.addEventListener('load', function () {
  // inViewアニメーション
  function checkElements() {
    const elements = document.querySelectorAll('.animate')
    const scroll = window.scrollY
    const windowHeight = window.innerHeight

    elements.forEach((element) => {
      const elemPos = element.getBoundingClientRect().top + scroll

      // 要素が表示領域に入っているかをチェック
      if (scroll > elemPos - windowHeight) {
        if (!element.classList.contains('is-current')) {
          element.classList.add('is-current')
        }
      }
    })
  }

  // スクロールイベントに対応
  document.addEventListener('scroll', checkElements)

  // ページ読み込み時にチェック
  function initialCheck() {
    checkElements()
    setTimeout(checkElements, 100) // 要素が完全にレンダリングされた後のチェック
  }

  initialCheck() // load イベント内で初期チェックを実行

  // リサイズ時にもチェック（ウィンドウサイズが変わったとき）
  window.addEventListener('resize', checkElements)
  const btn = document.querySelector('.fixed_btn')

  window.addEventListener('scroll', function () {
    const scroll = window.scrollY // スクロール値を毎回取得
    if (scroll > 100) {
      btn.classList.add('is-current')
    } else {
      btn.classList.remove('is-current')
    }
  })
  document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
    anchor.addEventListener('click', function (event) {
      event.preventDefault()
      const targetId = this.getAttribute('href').substring(1)
      const targetElement = document.getElementById(targetId)
      if (targetElement) {
        targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' })
      }
    })
  })
})
